import { SelectionStylesSchema } from './Selections.styles';

export const selectionStyles: SelectionStylesSchema = {
  errorWrapper: {
    mx: ['0', null, null, '-3'],
    mb: ['0', null, null, '-5'],
    zIndex: 'dropdown',
    position: 'sticky',
    flexDir: 'column',
    alignItems: 'center',
    bottom: '0',
    left: ['0', null, 'unset'],
    w: 'unset',
  },
};
